import React from "react";
import BizAirportDrodown from "./BizAirportDropdown";
import { useDestinationContext } from "../../contexts/DestinationContext";
import styled from "styled-components";
import InputDatePicker from "./Datepicker";
import TravelTimeSelect from "./TravelTimeSelect";
import PreferredAirlines from "./PreferredAirLines";
import Dropdown from "./DropdownField";
import DropdownTravelClass from "./DropdownTravelClass";
import DropdownFlightType from "./DropdownFlightType";
import DropdownPaymentType from "./DropdownPaymentType";
import DropdownCompanies from "./DropdownCompanies";

const TravelPreferenceForm = ({
  payType,
  travelType,
  data,
  onTravelTypeSelect,
  onPayTypeSelect,
  onCompanySelected,
  errors,
  companies,
  perDiemData,
  companyList,
  costCenterList,
  projectList,
  index = 0,
}) => {
  const getProjectIdLabel = (projectList, projectId) => {
    if (projectList?.length > 0) {
      let listItem = projectList?.filter((c) => c?.id === projectId)[0];
      return `${listItem?.name} (${projectId})`;
    } else {
      return "";
    }
  };
  return (
    <FormContainer>
      <RowWrapper>
        <DropdownWrapper>
          <Dropdown
            label="Payment Type"
            topOffset="72px"
            value={data?.paymentType}
            error={errors?.["paymentType"]}
            disabled={true}
          >
            <DropdownPaymentType
              payType={payType}
              selected={data?.paymentType}
              onPayTypeSelect={onPayTypeSelect}
            />
          </Dropdown>
        </DropdownWrapper>
        <DropdownWrapper>
          <Dropdown
            label="Travel Class"
            topOffset="72px"
            value={data?.travelClass}
            error={errors?.["travelClass"]}
            disabled={true}
          >
            <DropdownTravelClass
              travelType={travelType}
              selected={data?.travelClass}
              onTravelTypeSelect={onTravelTypeSelect}
            />
          </Dropdown>
        </DropdownWrapper>
      </RowWrapper>
      {index === 0 && (
        <RowWrapper>
          <DropdownWrapper>
            <Dropdown
              label="Travel cost to be borne by Company"
              topOffset="72px"
              value={
                data?.costBorneBy &&
                `${
                  companyList?.length > 0
                    ? companyList?.filter((c) => c?.id === data?.costBorneBy)[0]
                        ?.name
                    : ""
                } (${data?.costBorneBy})`
              }
              error={errors?.["costBorneBy"]}
              name="costBorneBy"
            >
              <DropdownCompanies
                name="costBorneBy"
                companies={companyList}
                selected={data?.costBorneBy}
                onCompanySelected={onCompanySelected}
                label="Travel cost to be borne by Company"
              />
            </Dropdown>
          </DropdownWrapper>
        </RowWrapper>
      )}
      {index === 0 && (
        <RowWrapper>
          <DropdownWrapper>
            <Dropdown
              label="Travel cost borne by Cost centre"
              topOffset="72px"
              value={
                data?.costCenter &&
                `${
                  data?.costCenter
                    ? costCenterList?.length > 0
                      ? costCenterList?.filter(
                          (c) => c?.id === data?.costCenter,
                        )[0]?.name
                      : ""
                    : ""
                } (${data?.costCenter})`
              }
              error={errors?.["costCenter"]}
              name="costCenter"
            >
              <DropdownCompanies
                name="costCenter"
                companies={[{ name: "Select", id: "" }, ...costCenterList]}
                selected={data?.costCenter}
                onCompanySelected={onCompanySelected}
                label="Travel cost borne by Cost centre"
              />
            </Dropdown>
          </DropdownWrapper>
          <DropdownWrapper>
            {projectList?.length > 0 && (
              <Dropdown
                required={false}
                label="Project ID"
                name="projectID"
                topOffset="72px"
                // value={
                //   data?.projectId
                //     ? getProjectIdLabel(projectList, data?.projectId)
                //     : ""
                // }
                value={data?.projectId}
                error={errors?.["projectId"]}
              >
                <DropdownCompanies
                  name="projectId"
                  companies={[{ name: "Select", id: "" }, ...projectList]}
                  selected={data?.projectId}
                  onCompanySelected={onCompanySelected}
                  label="Project ID"
                />
              </Dropdown>
            )}
          </DropdownWrapper>
        </RowWrapper>
      )}
    </FormContainer>
  );
};

export default TravelPreferenceForm;

const DateFieldContainer = styled.div`
  flex: 1;
`;

const FormContainer = styled.div`
  padding-top: 1.5rem;
`;

const DropdownWrapper = styled.div`
  flex: 1;
`;

const RowWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
  }
`;
